import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: {
    unit: 'Unit 10',
    id: 'WB3-U10-P73-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page73/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page73/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page73/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page73/E1/3.jpg', input: true, answer: "doing" },
        { url: 'img/FriendsPlus/Page73/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page73/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page73/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page73/E1/7.jpg', input: true, answer: "eating" },
        { url: 'img/FriendsPlus/Page73/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page73/E1/9.jpg', input: true, answer: "listening" },
        { url: 'img/FriendsPlus/Page73/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page73/E1/11.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 10',
    id: 'WB3-U10-P73-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 6,
    exerciseKey: 'img/FriendsPlus/Page73/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page73/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page73/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/5.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page73/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/7.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/9.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/11.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page73/E2/12.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page73/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/14.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/16.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page73/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/18.jpg', input: 8, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/19.jpg' },
        { url: 'img/FriendsPlus/Page73/E2/20.jpg', input: 9, isCorrect: true },
        { url: 'img/FriendsPlus/Page73/E2/21.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page73/E2/22.jpg' },
      ],
    ]
  },
  3: {
    unit: 'Unit 10',
    id: 'WB3-U10-P73-E3',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    hideBtnFooter: true,
    exerciseKey: 'img/FriendsPlus/Page73/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page73/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page73/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page73/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page73/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page73/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page73/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/13.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page73/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/16.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/17.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page73/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page73/E3/19.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page73/E3/20.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page73/E3/21.jpg' },
      ],

    ]
  },





}
export default json;